import React, { Component } from 'react';
//import { Media } from 'reactstrap';
//import AuthButton from './components/AuthButton';

class Rodape extends Component {
  render() {
    return (
      <div className="rodape d-none d-md-block">
        <div className="container">
          <footer className="footer rodape-footer">
            {/*<div className="row">
                            <Media list className="col-md-4">
                                {[
                                    {icon: "fa-phone", href: "tel:+558532192829", body:"(85) 3219-2829"},
                                    {icon: "fa-envelope", href: "mailto:contato@lupusbier.com.br", body:"contato@lupusbier.com.br"},
                                    {icon: "fa-map-marker", href: "https://goo.gl/maps/kdEdhYh35hT2", target: "_blank", rel: "noopener noreferrer", body: <span>Rua dos Tabajaras, 340 - Praia de Iracema<br />Fortaleza - CE, 60060-510</span>},
                                    {icon: "fa-clock-o", body:"Aberto de terça a sábado das 19:00 às 00:00"},
                                ].map(({icon, body, ...otherProps }, i) => (
                                    <Media tag="li" key={i}>
                                        <Media left {...otherProps}><i className={"fa fa-fw " + icon}></i></Media>
                                        <Media body>{body}</Media>
                                    </Media>
                                ))}
                                <AuthButton />
                            </Media>
                            <div className="col-md-5">
                                <h4 className="media-heading">Lupus Bier</h4>
                                <p>
                                    A Lupus Bier é considerada hoje a maior referência em casa de shows de humor do Ceará. Desde 2001 vem mostrando ao grande público o que o estado tem de mais representativo: o bom humor, produzido e encabeçado pela famosa Rossicléia - personagem da atriz Valéria Vitoriano.
                                </p>
                                <p className="social">
                                    {["facebook", "twitter", "instagram"].map((v, i) => (
                                        <a key={i} href={"http://" + v + ".com/lupusbier"} target="_blank" rel="noopener noreferrer"><i className={"fa fa-fw fa-" + v}></i></a>
                                    ))}
                                </p>
                            </div>
                            <div className="col-md-2">
                                <div className="pull-right text-center">

                                </div>
                            </div>
                        </div>*/}
            <div className="row">
              <div className="col-md-12">
                <h6 className="text-center">
                  Copyright © 2018+. Wesley Menezes. Todos os direitos
                  reservados.
                </h6>
              </div>
            </div>
          </footer>
        </div>
      </div>
    );
  }
}

export default Rodape;



// WEBPACK FOOTER //
// ./src/Rodape.js